import React, { useState } from 'react';

function FileUpload({ onFileUpload }) {
  const [dragOver, setDragOver] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    processFile(file);
  };

  const processFile = (file) => {
    if (file && (file.name.endsWith('.yml') || file.name.endsWith('.yaml'))) {
      const reader = new FileReader();
      reader.onload = (e) => onFileUpload(e.target.result);
      reader.readAsText(file);
    } else {
      alert('Please select a .yml or .yaml file');
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files[0];
    processFile(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = () => {
    setDragOver(false);
  };

  return (
    <div className="card shadow-lg border-0">
      <div className="card-body p-5">
        <div 
          className={`border-2 border-dashed rounded-3 p-5 text-center transition-all ${
            dragOver ? 'border-primary bg-primary bg-opacity-10' : 'border-secondary'
          }`}
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
        >
          <div className="mb-4">
            <i className="bi bi-cloud-upload display-1 text-primary"></i>
          </div>
          <h4 className="mb-3">Upload Configuration File</h4>
          <p className="text-muted mb-4">
            Drag and drop your <code>.yml</code> or <code>.yaml</code> file here, or click to browse
          </p>
          <input 
            type="file" 
            className="form-control form-control-lg" 
            accept=".yml,.yaml"
            onChange={handleFileChange}
            style={{ cursor: 'pointer' }}
          />
          <div className="mt-3">
            <small className="text-muted">
              <i className="bi bi-info-circle me-1"></i>
              Supported formats: .yml, .yaml
            </small>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FileUpload;